import * as React from 'react';
import { Divider, Col, Row } from 'antd';

import { Title } from '../../../components/Layout/components';
import Form from '../../../components/Form';
import GeneralSettingsCol from './components/General';
import ValueSettingsCol from './components/Values';

interface IVoucherGroupDetailProps {
  domain: string;
  voucherGroup: GQL.IVoucherGroup;
  languages: Array<GQL.ILanguage>;
  onSave: (voucherGroup: GQL.IVoucherGroup) => void;
  onCancel: () => void;
}

interface IVoucherGroupDetailState {
  voucherGroup: GQL.IVoucherGroup;
  deliveryMethodsIds: Array<string>;
  customerGroupsIds: Array<string>;
  currentLanguage: string;
  giftId?: string;
}

export default class VoucherGroupDetail extends React.Component<IVoucherGroupDetailProps, IVoucherGroupDetailState> {

  public constructor(props: IVoucherGroupDetailProps) {
    super(props);

    this.state = {
      voucherGroup: props.voucherGroup,
      deliveryMethodsIds: props.voucherGroup && props.voucherGroup.freeShipping
        ? props.voucherGroup.freeShipping.map(s => s.id)
        : [],
      customerGroupsIds: props.voucherGroup && props.voucherGroup.customerGroups
      ? props.voucherGroup.customerGroups.map(s => s.id)
      : [],
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { voucherGroup, currentLanguage } = this.state;

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {voucherGroup
            ? `Static discounts ${voucherGroup.title ? `"${voucherGroup.title}"` : ''}`
            : `Static discounts`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row gutter={30}>
            <Col md={24} lg={12}>
              <GeneralSettingsCol
                voucherGroup={voucherGroup}
                onChange={this.onChange}
              />
            </Col>
            <Col md={24} lg={12}>
              <ValueSettingsCol
                domain={this.props.domain}
                voucherGroup={voucherGroup}
                deliveryMethodsIds={this.state.deliveryMethodsIds}
                customerGroupsIds={this.state.customerGroupsIds}
                currentLanguage={currentLanguage}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    if (name === 'deliveryMethodsIds') {
      this.setState({
        deliveryMethodsIds: value,
      });
    } else if (name === 'customerGroupsIds') {
      this.setState({
        customerGroupsIds: value,
      });
    } else {
      // vše ostatní
      const newValue = (language
        ? { [name]: { ...this.state.voucherGroup[name], [language]: inputValue } }
        : { [name]: inputValue });
      this.setState({
        voucherGroup: { ...this.state.voucherGroup, ...newValue }
      });
    }
  }

  private async save() {
    const { voucherGroup } = this.state;

    const data = {
      ...voucherGroup,
      deliveryMethodsIds: this.state.deliveryMethodsIds,
      customerGroupsIds: this.state.customerGroupsIds
    };

    this.props.onSave(data);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticVoucherGroups/VoucherGroupDetail/VoucherGroupDetail.tsx